import { makeStyles } from '@material-ui/styles';

export const useStyles = makeStyles(() => ({
  root: {
    minHeight: '100%',
    padding: '28px 30px 48px',
    background: '#f5f8fb',
    color: '#16324a',
  },
  header: {
    display: 'flex',
    alignItems: 'flex-end',
    justifyContent: 'space-between',
    gap: 20,
    marginBottom: 24,
  },
  eyebrow: {
    marginBottom: 6,
    color: '#0084c3',
    fontSize: 11,
    fontWeight: 800,
    letterSpacing: '0.14em',
    textTransform: 'uppercase',
  },
  title: {
    margin: 0,
    color: '#003057',
    fontSize: 'clamp(25px, 3vw, 38px)',
    fontWeight: 800,
    letterSpacing: '-0.04em',
  },
  subtitle: {
    margin: '8px 0 0',
    color: '#6f8292',
    fontSize: 14,
  },
  updated: {
    display: 'flex',
    alignItems: 'center',
    gap: 7,
    padding: '9px 12px',
    border: '1px solid #dbe7ec',
    borderRadius: 9,
    background: '#fff',
    color: '#66808e',
    fontSize: 12,
    whiteSpace: 'nowrap',
  },
  liveDot: {
    width: 7,
    height: 7,
    borderRadius: '50%',
    background: '#0084c3',
    boxShadow: '0 0 0 4px #dff3fa',
  },
  panel: {
    height: '100%',
    padding: 20,
    border: '1px solid #e0e9ee',
    borderRadius: 12,
    background: '#fff',
    boxShadow: '0 8px 24px rgba(31, 69, 91, 0.05)',
  },
  filterPanel: {
    marginBottom: 22,
    padding: 18,
    border: '1px solid #dce9ee',
    borderRadius: 12,
    background: '#fff',
  },
  filterTitle: {
    color: '#003057',
    fontSize: 13,
    fontWeight: 800,
    letterSpacing: '0.02em',
  },
  filterHeader: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    marginBottom: 14,
  },
  filterLabel: {
    display: 'block',
    marginBottom: 6,
    color: '#718693',
    fontSize: 11,
    fontWeight: 700,
    textTransform: 'uppercase',
  },
  select: {
    width: '100%',
    '& .MuiOutlinedInput-root': {
      borderRadius: 8,
      background: '#fbfdfe',
      fontSize: 13,
    },
  },
  periodButton: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    width: '100%',
    minHeight: 40,
    padding: '7px 10px 7px 13px',
    border: '1px solid #b9dce0',
    borderRadius: 8,
    background: '#fbfdfe',
    color: '#003057',
    fontSize: 13,
    fontWeight: 500,
    textTransform: 'none',
  },
  periodPopover: {
    display: 'flex',
    width: 640,
    maxWidth: 'calc(100vw - 32px)',
    height: 285,
    maxHeight: 'calc(100vh - 32px)',
    overflow: 'hidden',
    background: '#fff',
    '@media (max-width: 600px)': {
      flexDirection: 'column',
    },
  },
  periodPresets: {
    display: 'flex',
    width: 190,
    minHeight: 0,
    flexDirection: 'column',
    padding: 10,
    overflowY: 'auto',
    borderRight: '1px solid #e2edf2',
    scrollbarWidth: 'thin',
    '&::-webkit-scrollbar': {
      width: 6,
    },
    '&::-webkit-scrollbar-thumb': {
      borderRadius: 6,
      background: '#9fcde1',
    },
    '@media (max-width: 600px)': {
      width: 'auto',
      maxHeight: 150,
      borderRight: 0,
      borderBottom: '1px solid #e2edf2',
    },
  },
  periodPreset: {
    justifyContent: 'flex-start',
    minHeight: 34,
    padding: '6px 10px',
    borderRadius: 6,
    color: '#375469',
    fontSize: 12,
    textAlign: 'left',
    textTransform: 'none',
  },
  periodPresetActive: {
    justifyContent: 'flex-start',
    minHeight: 34,
    padding: '6px 10px',
    borderRadius: 6,
    background: '#e4f5fb',
    color: '#003057',
    fontSize: 12,
    fontWeight: 800,
    textAlign: 'left',
    textTransform: 'none',
  },
  periodCalendarArea: {
    display: 'flex',
    flex: 1,
    flexDirection: 'column',
    padding: 20,
  },
  periodCalendarTitle: {
    marginBottom: 14,
    color: '#003057',
    fontSize: 13,
    fontWeight: 800,
  },
  periodCalendars: {
    display: 'grid',
    gridTemplateColumns: '1fr 1fr',
    gap: 16,
    '@media (max-width: 600px)': {
      gridTemplateColumns: '1fr',
    },
  },
  periodActions: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    gap: 8,
    marginTop: 'auto',
    paddingTop: 20,
    '& .MuiButton-containedPrimary': {
      background: '#003057',
    },
  },
  clearButton: {
    minWidth: 0,
    height: 30,
    padding: '4px 10px',
    border: '1px solid #9fcde1',
    borderRadius: 8,
    color: '#0084c3',
    fontSize: 10,
    fontWeight: 700,
    textTransform: 'none',
  },
  customFieldsDivider: {
    height: 1,
    flex: 1,
    background: '#e2edf2',
  },
  customFieldsHeader: {
    display: 'flex',
    alignItems: 'center',
    gap: 12,
    margin: '18px 0 16px',
  },
  customFieldsButton: {
    minWidth: 0,
    padding: '5px 12px',
    borderRadius: 16,
    background: '#e4f5fb',
    color: '#003057',
    fontSize: 11,
    fontWeight: 800,
    textTransform: 'none',
  },
  dialogDescription: {
    marginBottom: 12,
    color: '#66808e',
    fontSize: 13,
  },
  customFieldsChecklist: {
    display: 'grid',
    gridTemplateColumns: 'repeat(2, minmax(0, 1fr))',
    gap: 4,
  },
  kpi: {
    position: 'relative',
    overflow: 'hidden',
    minHeight: 116,
    padding: '18px 20px',
    border: '1px solid #e0e9ee',
    borderRadius: 12,
    background: '#fff',
    boxShadow: '0 8px 24px rgba(31, 69, 91, 0.05)',
    '&:after': {
      position: 'absolute',
      right: -24,
      bottom: -38,
      width: 105,
      height: 105,
      borderRadius: '50%',
      background: 'rgba(28, 157, 163, 0.08)',
      content: '""',
    },
  },
  kpiHeader: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: 10,
  },
  kpiIcon: {
    position: 'relative',
    zIndex: 1,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: 38,
    height: 38,
    flex: '0 0 38px',
    borderRadius: 12,
  },
  kpiIconBlue: {
    background: '#e4f5fb',
    color: '#0084c3',
  },
  kpiIconGreen: {
    background: '#e9f0f7',
    color: '#003057',
  },
  kpiLabel: {
    color: '#7a8e9c',
    fontSize: 11,
    fontWeight: 800,
    letterSpacing: '0.05em',
    textTransform: 'uppercase',
  },
  kpiValue: {
    marginTop: 8,
    color: '#003057',
    fontSize: 28,
    fontWeight: 800,
    letterSpacing: '-0.04em',
  },
  kpiHint: {
    marginTop: 3,
    color: '#0084c3',
    fontSize: 11,
  },
  panelTitle: {
    margin: 0,
    color: '#003057',
    fontSize: 15,
    fontWeight: 800,
  },
  panelHeader: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: 12,
  },
  panelSubtitle: {
    margin: '4px 0 18px',
    color: '#91a0aa',
    fontSize: 11,
  },
  chartBox: {
    position: 'relative',
    height: 255,
  },
  statusContent: {
    display: 'flex',
    alignItems: 'center',
    minHeight: 255,
    gap: 12,
  },
  statusChartBox: {
    position: 'relative',
    width: '52%',
    height: 210,
    flex: '0 0 52%',
  },
  statusCenter: {
    position: 'absolute',
    top: '50%',
    left: '50%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexDirection: 'column',
    transform: 'translate(-50%, -50%)',
    pointerEvents: 'none',
    '& strong': {
      color: '#16324a',
      fontSize: 22,
      fontWeight: 800,
    },
    '& span': {
      color: '#8a9aa5',
      fontSize: 10,
    },
  },
  statusLegend: {
    display: 'flex',
    flex: 1,
    flexDirection: 'column',
    gap: 12,
  },
  statusLegendRow: {
    display: 'grid',
    gridTemplateColumns: '10px minmax(0, 1fr) auto 30px',
    alignItems: 'center',
    gap: 7,
    color: '#29455a',
    fontSize: 11,
  },
  statusLegendDot: {
    width: 9,
    height: 9,
    borderRadius: '50%',
  },
  statusLegendName: {
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
  },
  statusLegendPercentage: {
    color: '#8a9aa5',
    textAlign: 'right',
  },
  wideChartBox: {
    position: 'relative',
    height: 310,
  },
  workloadTableWrap: {
    height: 255,
    overflowY: 'auto',
    marginTop: 4,
  },
  podium: {
    display: 'grid',
    perspective: 700,
    gridTemplateColumns: 'repeat(3, minmax(0, 1fr))',
    alignItems: 'end',
    gap: 12,
    minHeight: 220,
    marginTop: -10,
    padding: '6px 8px 8px',
    '@media (max-width: 600px)': {
      gap: 6,
      paddingLeft: 0,
      paddingRight: 0,
    },
  },
  podiumItem: {
    display: 'flex',
    minWidth: 0,
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'flex-end',
    padding: '14px 8px 12px',
    borderRadius: '10px 10px 4px 4px',
    background: 'linear-gradient(145deg, #ffffff 0%, #edf3f7 100%)',
    boxShadow: '0 10px 16px rgba(31, 69, 91, 0.16), inset 0 1px 0 rgba(255, 255, 255, 0.9)',
    color: '#375469',
    transform: 'rotateX(2deg)',
    transformOrigin: 'bottom',
    textAlign: 'center',
  },
  podiumItem1: {
    minHeight: 190,
    borderTop: '5px solid #f2b84b',
    background: 'linear-gradient(145deg, #fffdf5 0%, #f8e9bd 100%)',
    boxShadow: '0 14px 20px rgba(174, 127, 35, 0.24), inset 0 1px 0 rgba(255, 255, 255, 0.95)',
  },
  podiumItem2: {
    minHeight: 155,
    borderTop: '5px solid #aebbc4',
    background: 'linear-gradient(145deg, #ffffff 0%, #dfe7ec 100%)',
  },
  podiumItem3: {
    minHeight: 130,
    borderTop: '5px solid #b8794b',
    background: 'linear-gradient(145deg, #fffaf6 0%, #ead4c5 100%)',
  },
  podiumPosition: {
    marginBottom: 15,
    color: '#003057',
    fontSize: 24,
    fontWeight: 800,
  },
  podiumTrophy: {
    display: 'block',
    margin: '0 auto 9px',
    color: '#d99b16',
    transform: 'translateY(-7px)',
    fontSize: 38,
  },
  podiumName: {
    width: '100%',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    fontSize: 12,
    fontWeight: 800,
  },
  podiumCompleted: {
    marginTop: 7,
    color: '#0084c3',
    fontSize: 11,
    fontWeight: 700,
  },
  workloadTable: {
    width: '100%',
    borderCollapse: 'collapse',
    '& th': {
      padding: '9px 6px',
      background: '#003057',
      color: '#fff',
      fontSize: 10,
      fontWeight: 800,
      textAlign: 'left',
    },
    '& td': {
      padding: '10px 6px',
      borderBottom: '1px solid #edf2f4',
      color: '#375469',
      fontSize: 11,
    },
    '& th:last-child, & td:last-child': {
      textAlign: 'right',
    },
  },
  customChart: {
    position: 'relative',
    height: 250,
  },
  tableWrap: {
    overflowX: 'auto',
  },
  downloadButton: {
    minHeight: 30,
    border: '1px solid #b9dce0',
    borderRadius: 8,
    color: '#168c96',
    fontSize: 11,
    fontWeight: 800,
  },
  pagination: {
    display: 'flex',
    justifyContent: 'flex-end',
    paddingTop: 18,
  },
  table: {
    width: '100%',
    minWidth: 820,
    borderCollapse: 'collapse',
    '& th': {
      padding: '12px 10px',
      borderBottom: '1px solid #e4edf1',
      color: '#7c909b',
      fontSize: 10,
      fontWeight: 800,
      letterSpacing: '0.05em',
      textAlign: 'left',
      textTransform: 'uppercase',
    },
    '& td': {
      padding: '13px 10px',
      borderBottom: '1px solid #edf2f4',
      color: '#375469',
      fontSize: 12,
    },
  },
  status: {
    display: 'inline-flex',
    padding: '5px 9px',
    borderRadius: 20,
    background: '#e8f5f1',
    color: '#258b72',
    fontSize: 10,
    fontWeight: 800,
  },
  empty: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    height: '100%',
    color: '#9aaab3',
    fontSize: 13,
  },
  loading: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    minHeight: 420,
    color: '#168c96',
    fontSize: 14,
    fontWeight: 700,
  },
}));
